import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  id,
  className = ""
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-4 py-4 text-center font-display text-[19px] font-extrabold uppercase leading-tight tracking-wide text-cta-ink shadow-[0_6px_0_0_#b98200] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-[0_2px_0_0_#b98200] focus:outline-none focus-visible:ring-4 focus-visible:ring-electric-light sm:py-5 sm:text-2xl ${className}`} data-id="element-29" data-mp="2kwbpdyth92hr">
      <span data-id="element-30" data-mp="3cp2p4jadd9br">{label}</span>
      <ArrowRightIcon className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-31" data-mp="3cqdpsa8iq0yn" />
    </a>;
}